import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPaychexSSORedirectContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PaychexSSORedirectContainer" */
                '@perpay-web/fintech/components/composite/PaychexOnboarding/PaychexSSORedirectContainer'
            ),
    );
